/* Greenleaf — Quick look and the "Back to <shelf>" pill. New 13 Oct 2026 (Andrew's yes, relayed).
 *
 * QUICK LOOK. Each product card on a shelf carries a hidden <button data-ql="<handle>">
 * (snippets/gl-cards.liquid). With this file loaded the button shows (on hover or keyboard
 * focus for a mouse; always, as a small pill, on a touch screen) and opens a side panel with
 * the piece's photos (swipe), name, price, the in-the-case line, Add to bag and "See full
 * details". The panel's contents are fetched with the Section Rendering API,
 *   /products/<handle>?section_id=gl-quick-look
 * (sections/gl-quick-look.liquid, asked for by its FILE name: the store answers 404 to a
 * template key, checked live 13 Oct), cached per handle, and written in as markup that comes
 * from our own theme, never from the address. The handle is checked before use.
 * Esc and the scrim close it, Tab stays inside it, focus returns to the card's button. Add to
 * bag goes through the same code as the product page (window.glBag.bindForm), so the photo
 * flies to the bag; the panel closes as the bag opens.
 *
 * BACK PILL. On a shelf this file remembers, for the tab (sessionStorage `glLastShelf`), the
 * shelf's address and name. On a product page whose referrer is exactly that shelf, a quiet
 * pill "Back to <name>" sits under the breadcrumb. It is a real link to the shelf; with script
 * a click is the browser's Back instead, which is what puts the shelf at the exact place
 * (gl-show-more.js restores page and scroll on Back).
 */
(function () {
  'use strict';
  var HANDLE = /^[a-z0-9][a-z0-9-]*$/i;
  function ss(k, v) {
    try {
      if (v === undefined) return JSON.parse(window.sessionStorage.getItem(k));
      window.sessionStorage.setItem(k, JSON.stringify(v));
    } catch (e) {}
    return null;
  }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  // ---- back pill -------------------------------------------------------------------
  var path = window.location.pathname;
  if (/^\/collections\/[^/]+\/?$/.test(path) && document.querySelector('.card')) {
    var h1 = document.querySelector('h1');
    var name = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
    if (name) ss('glLastShelf', { url: path + window.location.search, name: name });
  } else if (/^\/products\//.test(path) && document.referrer) {
    try {
      var ref = new URL(document.referrer), last = ss('glLastShelf');
      var nav = document.querySelector('nav.crumbs');
      if (last && nav && ref.origin === window.location.origin && ref.pathname + ref.search === last.url) {
        var row = document.createElement('div');
        row.className = 'gl-backpill';
        var wrap = document.createElement('div');
        wrap.className = 'wrap';
        var a = document.createElement('a');
        a.href = last.url;
        a.textContent = 'Back to ' + last.name.toLowerCase();
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
          if (window.history.length > 1) { e.preventDefault(); window.history.back(); }
        });
        wrap.appendChild(a);
        row.appendChild(wrap);
        nav.parentNode.insertBefore(row, nav.nextSibling);
      }
    } catch (e) {}
  }

  // ---- quick look ------------------------------------------------------------------
  var buttons = document.querySelectorAll('.card__ql');
  if (!buttons.length || !window.fetch) return;
  Array.prototype.forEach.call(buttons, function (b) { b.hidden = false; });

  var active = false, root = null, panel = null, closeBtn = null, body = null, opener = null, cache = {}, token = 0;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function build() {
    root = document.createElement('div');
    root.className = 'gl-ql';
    root.hidden = true;
    root.innerHTML = '<div class="gl-ql__scrim" data-ql-close></div>' +
      '<div class="gl-ql__panel" role="dialog" aria-modal="true" aria-label="Quick look" tabindex="-1">' +
      '<button class="gl-ql__close" type="button" data-ql-close aria-label="Close quick look">&times;</button>' +
      '<div data-ql-slot></div></div>';
    document.body.appendChild(root);
    panel = root.querySelector('.gl-ql__panel');
    closeBtn = root.querySelector('.gl-ql__close');
    body = root.querySelector('[data-ql-slot]');
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ql-close]')) close(true);
    });
  }

  function load(handle) {
    if (!cache[handle]) {
      var p = fetch('/products/' + encodeURIComponent(handle) + '?section_id=gl-quick-look', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) { return html.indexOf('data-ql-body') > -1 ? html : null; })
        // A failure is not remembered, so opening it again tries again.
        .catch(function () { if (cache[handle] === p) delete cache[handle]; return null; });
      cache[handle] = p;
    }
    return cache[handle];
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(true); return; }
    if (e.key !== 'Tab') return;
    var items = panel.querySelectorAll(FOCUSABLE);
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    var first = items[0], last = items[items.length - 1], act = document.activeElement;
    if (e.shiftKey && (act === first || act === panel || !panel.contains(act))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (act === last || !panel.contains(act))) { e.preventDefault(); first.focus(); }
  }

  // Previous / next for the photo strip (15 Oct 2026, phone audit). The strip is a scroll-snap row, so a
  // step is a scroll by one strip width; the buttons disable at either end and the line under the photo
  // says which photo is showing. A swipe, or the arrow keys on the focused strip, still work as before.
  function gallery(scope) {
    var strip = scope.querySelector('.gl-ql__photos');
    var prev = scope.querySelector('[data-ql-prev]'), next = scope.querySelector('[data-ql-next]');
    var count = scope.querySelector('[data-ql-count]');
    if (!strip || !prev || !next) return;
    var imgs = strip.querySelectorAll('img');
    if (imgs.length < 2) return;
    prev.hidden = false; next.hidden = false;
    function at() { return Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth)); }
    function sync() {
      var i = at();
      prev.disabled = i <= 0;
      next.disabled = i >= imgs.length - 1;
      if (count) count.textContent = 'Photo ' + (i + 1) + ' of ' + imgs.length;
    }
    function go(d) {
      var i = Math.max(0, Math.min(imgs.length - 1, at() + d));
      strip.scrollTo({ left: i * strip.clientWidth, behavior: reduced() ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    strip.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function open(btn) {
    var handle = btn.getAttribute('data-ql') || '';
    if (!HANDLE.test(handle)) return;
    if (!root) build();
    opener = btn;
    active = true;
    var mine = ++token;
    body.innerHTML = '<p class="gl-ql__status">Opening…</p>';
    root.hidden = false;
    document.documentElement.classList.add('ql-open');
    if (window.requestAnimationFrame && !reduced()) requestAnimationFrame(function () { if (active) root.classList.add('is-open'); });
    else root.classList.add('is-open');
    document.addEventListener('keydown', onKey);
    closeBtn.focus();
    load(handle).then(function (html) {
      if (mine !== token || root.hidden) return;
      if (!html) {
        // Could not load it. It used to send the shopper away to the piece's page without a word (audit,
        // 15 Oct 2026); now the panel says so and offers that page as a link, and the shopper chooses.
        body.textContent = '';
        var msg = document.createElement('p');
        msg.className = 'gl-ql__status';
        msg.appendChild(document.createTextNode('Couldn\u2019t open, '));
        var more = document.createElement('a');
        more.href = '/products/' + encodeURIComponent(handle);
        more.textContent = 'see full details';
        msg.appendChild(more);
        body.appendChild(msg);
        return;
      }
      body.innerHTML = html;
      gallery(body);
      var form = body.querySelector('form[action*="/cart/add"]');
      if (form && window.glBag && window.glBag.bindForm) window.glBag.bindForm(form);
      closeBtn.focus();
    });
  }

  function close(returnFocus) {
    // `active` (not the is-open class) is the guard: the class is added a frame late, so a
    // close before that frame must still work, and the bag observer below cannot loop on itself.
    if (!root || !active) return;
    active = false;
    token++;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('ql-open');
    document.removeEventListener('keydown', onKey);
    // Skip the tidy-up if the panel was opened again in the meantime.
    var done = function () { if (active) return; root.hidden = true; body.innerHTML = ''; };
    if (reduced()) done(); else setTimeout(done, 380);
    if (returnFocus && opener && opener.focus) opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.card__ql') : null;
    if (!b) return;
    e.preventDefault();
    open(b);
  });

  // The bag opening (after an Add to bag in the panel) takes over: the panel steps aside.
  if (window.MutationObserver) {
    new MutationObserver(function () {
      // Guarded by is-open: close() removes it, so this cannot call itself again (a class write
      // on <html> queues another mutation record even when nothing changes).
      if (active && document.documentElement.classList.contains('bag-open')) close(false);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
})();
